import { render, staticRenderFns } from "./pre_span.vue?vue&type=template&id=30016248&scoped=true"
import script from "./pre_span.vue?vue&type=script&lang=js"
export * from "./pre_span.vue?vue&type=script&lang=js"
import style0 from "./pre_span.vue?vue&type=style&index=0&id=30016248&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30016248",
  null
  
)

export default component.exports